<template>
    <div style="height: 100%">
        <div style="padding-left: 20px;height: 57.5px; line-height: 57.5px;background-color: #2d2f31; display: flex; align-items: center">
            <div style="padding-right: 10px; width: 42px;"
                 v-if="isCheckedList">
                <v-checkbox v-if="items&&items.length"
                            color="blue darken-1"
                            v-model="checked"
                            :indeterminate="checkedItems.length>0&&checkedItems.length!==items.length"
                            dark/>
            </div>
            <div class="ui search">
                <div class="ui icon input">
                    <input
                            class="prompt"
                            type="text"
                            placeholder="Поиск..."
                            v-model="labelFilter"
                            style=" background-color: #151515; color: white; border-color: #2185d0; border-width: 2px;">
                    <i class="search icon" style="color: white"></i>
                </div>
                <div class="results"></div>
            </div>
            <div style="margin-left: auto">
                <slot name="header"></slot>
            </div>
        </div>
        <div style="height: calc(100% - 56px)">
            <div class="ui inverted relaxed divided selection list"
                 style="margin-top: 0;height: 100%;overflow-y: auto;overflow-x: hidden;padding-bottom: 75px">
                <template v-for="(items, groupName) in groupedItems">
                    <div class="item group-name"
                         style="text-align: center; padding: 10pt 10pt;color: rgb(171, 169, 169);border: 0;cursor: default;"
                         v-if="groupName!==''"
                    >
                        <span class="v-chip__content"
                              style=" background-color: #151515; padding-left: 20px; padding-right: 20px;">
                            {{groupName}}
                        </span>
                    </div>
                    <vue-list-item v-for="(item,index) of items"
                                   :key="item.id"
                                   :item="item"
                                   :buttons="buttons"
                                   :checkable="isCheckedList"
                                   :checkedItems.sync="checkedItems"
                                   :selected="item.id===selectedItem"
                                   :style="{'border-top':index===0?'0px':undefined, 'border-bottom':index===items.length-1?'0px':undefined}"
                                   @click="onItemClick(item.id)"
                    >
                        <template slot-scope="{item}">
                            <slot :item="item"></slot>
                        </template>
                    </vue-list-item>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import VueListItem from './vue-list-item'

    import {groupBy} from 'lodash/collection'
    import {intersection} from 'lodash/array'

    import 'semantic-ui-css/components/list.css'
    import 'semantic-ui-css/components/search.css'
    import 'semantic-ui-css/components/input.css'

    export default {
        props: {
            items: {
                type: Array,
                default: () => []
            },
            marginBottom: {
                type: String,
                default: null
            },
            buttons: {
                type: Array,
                default: () => []
            },
            selectedItem: {
                type: String,
                default: null
            },
            searchBy: {
                type: String,
                default: 'label'
            },
            groupBy: {
                type: Function,
                default: null
            },
            isCheckedList: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                labelFilter: '',
                checked: false,
                checkedItems: []
            }
        },
        computed: {
            filteredItems() {
                return this.items.filter(item => item[this.searchBy].toLowerCase().includes(this.labelFilter.toLowerCase()));
            },
            groupedItems() {
                return this.groupBy ? groupBy(this.filteredItems, this.groupBy) : {'': this.filteredItems};
            }
        },
        methods: {
            onButtonClick: function (button, itemId) {
                if (button.onClick)
                    button.onClick(itemId);
            },
            onItemClick: function (id) {
                this.updateSelectedItem(id === this.selectedItem ? null : id);
            },
            updateSelectedItem(val) {
                this.$emit('update:selectedItem', val);
            }
        },

        components: {
            VueListItem
        },
        watch: {
            labelFilter() {
                this.updateSelectedItem(null);
            },
            checked(newVal) {
                if (newVal) {
                    if (this.checkedItems.length === 0)
                        this.checkedItems = this.items.map(({id}) => id);
                } else this.checkedItems = []
            },
            checkedItems(newVal) {
                this.checked = newVal.length > 0;
                this.$emit('checkedItemsChanged', newVal);
            },
            items(newVal) {
                this.checkedItems = intersection(newVal.map(({id}) => id), this.checkedItems);
            }
        }
    }
</script>

<style>
    .item.group-name {
        background: linear-gradient(
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0) 49%,
                rgb(171, 169, 169) 50%,
                rgb(171, 169, 169) 51%,
                rgba(255, 255, 255, 0) 52%,
                rgba(255, 255, 255, 0) 100%) !important;
    }
</style>
